import { IApplicationState, TBoardId } from '../../../../types/types';
import { IBoardExportSettings } from '../../../../types/rest/IRestUserBoardMeta';
import { getBoardUserMeta } from '../../boardUserMetas/selectors/getBoardUserMeta';

export const getBoardExportSettings = (
    state: IApplicationState,
    boardId: TBoardId
): IBoardExportSettings => {
    const userBoardMeta = getBoardUserMeta(state, boardId);

    return userBoardMeta && userBoardMeta.exportSettings;
};
